import React from 'react';

import { ChargingStationInterFace } from '../../../interface/charging-station.interface';

import UnapprovedElectricityPrice from './UnapprovedElectricityPrice';
import UnApprovedStationList from './UnapprovedStationList';

interface UnapprovedListingProperties {
  viewFunction: (value: ChargingStationInterFace) => void;
  currentPage: string;
  setCurrentPage: (value: string) => void;
  handleDeleteStationWarning: (value: string | undefined) => void;
}

/**
 * Function to toggle between unapproved station and unapproved electric price
 * @returns
 */
function UnapprovedListing(properties: UnapprovedListingProperties) {
  const {  currentPage, setCurrentPage,handleDeleteStationWarning } = properties;

  return (
    <div className="unapproved-list-toggle-wrap">
      {currentPage === 'station' && (
        <UnApprovedStationList
          handleDeleteStationWarning={handleDeleteStationWarning}
        />
      )}
      {currentPage === 'electricityPrice' && (
        <UnapprovedElectricityPrice currentPage={currentPage} setCurrentPage={setCurrentPage} />
      )}
    </div>
  );
}

export default UnapprovedListing;
